import * as React from 'react';

const CardReaderFillSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            d="M3.999 2L2 16h7.999v6h4v-6h8L20 2H3.999zm2.4 3.001h11.2L18.311 10h-1.009l-.571-3.999H7.267L6.697 10h-1.01l.712-4.999zm4.6 14h2V16h-2v3.001zm0 1.999h2v-1h-2v1z"
        />
    </svg>
);

CardReaderFillSvg.displayName = 'CardReaderFillSvg';
export default CardReaderFillSvg;
